import {createAction, createReducer} from '@reduxjs/toolkit';

export const initialState = true;

export const setAddressesSameness = createAction<boolean>('CHECKOUT@SET_ADDRESSES_SAMENESS');

export const startSetAddressesSamenessSaga = createAction<boolean>(
    'CHECKOUT@START_SET_ADDRESSES_SAMENESS_SAGA',
);

/**
 * Billing and shipping addresses state
 * @return {boolean} State
 */
export const billingAndShippingIsSame = createReducer(initialState, builder =>
    builder.addCase(setAddressesSameness, (_, action) => action.payload),
);
